import * as React from 'react';
import { CSSProperties } from 'react';

interface IProps {
    onClick: () => void,

}
export const ArrowNext = ({ onClick }: IProps) => {

    return <div className={`arrow-next-container`} onClick={onClick}>
        <span className={"arrow-down"} />
    </div>
}